export const getSpaceRentalTotal = (spaceRentalContract, profile) => {
  const spaceRentalFee =
    (spaceRentalContract?.primary_amount || {})[profile.SSOid] || 0;
  const cleaningFeeObj = (spaceRentalContract?.secondary_charges || []).find(
    (c) => c.type === 'upcharge'
  );
  const cleaningFee = (cleaningFeeObj?.amount || {})[profile.SSOid] || 0;
  const spaceRentalTotal = +spaceRentalFee + +cleaningFee;
  return spaceRentalTotal;
};
